<span>{{ data.message }}</span>
@if (data.action) {
  <div class="mat-simple-snackbar-action custom-notification-actions">
    <button semerisButton variant="outline" (click)="onDismiss(data.action)">{{ data.action }}</button>
    @if (data.closable) {
      <button semerisIconButton  (click)="onDismiss()">
        <mat-icon>clear</mat-icon>
      </button>
    }
  </div>
}
